import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../filters/translate.pipe';

@Component({
	standalone: true,
	selector: 'toolkit-surveys',
	templateUrl: './toolkit-surveys.component.html',
	imports: [CommonModule, TranslatePipe]
})
export class ToolkitSurveysComponent {
	@Input() vm: any;

	truncateDescription(value: any, limit = 80): string {
		const text = (value || '').toString().trim();
		if (!text) return '';
		return text.length > limit ? text.slice(0, limit) + '...' : text;
	}
}
